// extracted by mini-css-extract-plugin
module.exports = {"Container":"Header_Container__3N5l5","ImgLogo":"Header_ImgLogo__2uFu_"};